module.exports = __webpack_public_path__ + "img/image6.e234b627.jpg";